function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import { Button } from '@progress/kendo-react-buttons';
import ServiceFactory from '../../service';
import Auth from "../../functions/authenticate";
import { US_STATES } from "../sales/territory-common";
import { AprListCard, StatusChip, rowId, isDone, isFailed } from "./company";
import { readableDate } from "./company-detail";
import { parseTrendData, weeklySeries, trendDirection } from "./market-trends-detail";

/*
 * Market Trends list (apps redesign 2026-10-09). Same card and table as
 * Company Analysis: pills (All plus one per direction present), search,
 * Term / Where / Period / Direction / Created / "···". Direction is
 * computed from each report's interest series. Running rows show a
 * Running chip and the list polls until they finish.
 *
 * New-report form: a modal with one required input (the term) and the
 * defaults shown as selected values (United States, last 12 months, Auto
 * category). "Custom range…" hands off to /Research/Trends/Add.
 */
const TERM_CHIPS = ["eco-friendly packaging", "meal prep services", "home office desks", "electric bikes"];
const WINDOWS = [["12m", "Last 12 months (default)"], ["5y", "Last 5 years"], ["90d", "Last 90 days"], ["custom", "Custom range…"]];
// Google Trends taxonomy top-level ids (0 = all categories / auto)
const CATEGORIES = [[0, "Auto (recommended)"], [11, "Home & Garden"], [18, "Shopping"]];
const iso = d => d.toISOString().slice(0, 10);
const SHORT_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function periodText(from, to) {
  const a = new Date(from),
    b = new Date(to);
  if (isNaN(a.getTime()) || isNaN(b.getTime())) return "";
  const fmt = d => `${SHORT_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  return `${fmt(a)} to ${fmt(b)}`;
}
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "refreshRows", async () => {
      try {
        const Service = ServiceFactory.getType('/market-trends', 'research');
        const rows = await new Service().getAsync();
        const list = Array.isArray(rows) ? rows : rows.items || [];
        if (this._alive) this.setState({
          rows: list
        }, () => this.ensurePolling());
      } catch (e) {/* keep polling */}
    });
    _defineProperty(this, "submit", () => {
      const {
        term,
        locationSel,
        windowSel,
        categoryCode,
        submitting
      } = this.state;
      if (!term.trim() || submitting) return;
      if (windowSel === "custom") {
        this.props.history.push('/Research/Trends/Add');
        return;
      }
      const to = new Date();
      const from = new Date();
      if (windowSel === "5y") from.setFullYear(from.getFullYear() - 5);else if (windowSel === "90d") from.setDate(from.getDate() - 90);else from.setFullYear(from.getFullYear() - 1);
      const auth = Auth.get() || {};
      this.setState({
        submitting: true
      });
      const Service = ServiceFactory.getType('/market-trends', 'research');
      new Service().post({
        term: term.trim(),
        fromDate: iso(from),
        toDate: iso(to),
        location: locationSel,
        categoryCode,
        languageCode: 'en',
        userId: auth.email || ''
      }, err => {
        if (!this._alive) return;
        if (err) {
          this.setState({
            submitting: false,
            running: {
              term: term.trim(),
              failed: true
            }
          });
          return;
        }
        const startedAt = Date.now();
        this.setState({
          modal: false,
          submitting: false,
          term: "",
          running: {
            term: term.trim(),
            startedAt,
            elapsed: 0
          }
        });
        this._tick = setInterval(() => {
          if (this.state.running && this.state.running.startedAt) {
            this.setState({
              running: {
                ...this.state.running,
                elapsed: Math.floor((Date.now() - startedAt) / 1000)
              }
            });
          }
        }, 1000);
        this._poll = setInterval(this.checkRun(term.trim(), startedAt), 8000);
        this.refreshRows();
      });
    });
    // Poll until this term's newest row completes, then flip the strip to
    // "ready" with a direct Open link.
    _defineProperty(this, "checkRun", (term, startedAt) => async () => {
      try {
        const Service = ServiceFactory.getType('/market-trends', 'research');
        const rows = await new Service().getAsync();
        const list = Array.isArray(rows) ? rows : rows.items || [];
        if (this._alive) this.setState({
          rows: list
        });
        const mine = list.filter(r => String(r.term).toLowerCase() === term.toLowerCase()).sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))[0];
        if (!mine || !this._alive) return;
        const status = String(mine.status || "");
        if (/completed/i.test(status)) {
          clearInterval(this._tick);
          clearInterval(this._poll);
          this.setState({
            running: {
              term,
              reportId: rowId(mine)
            }
          });
        } else if (/fail|error/i.test(status)) {
          clearInterval(this._tick);
          clearInterval(this._poll);
          this.setState({
            running: {
              term,
              failed: true
            }
          });
        }
      } catch (e) {/* keep polling */}
    });
    _defineProperty(this, "onDelete", (id, done) => {
      const Service = ServiceFactory.getType('/market-trends', 'research');
      new Service().delete(id, err => {
        if (!this._alive) return;
        done();
        if (!err) this.setState({
          rows: this.state.rows.filter(r => rowId(r) !== id)
        });
      });
    });
    this.state = {
      rows: props.data || [],
      pill: "all",
      search: "",
      modal: false,
      term: "",
      locationSel: "United States",
      windowSel: "12m",
      categoryCode: 0,
      submitting: false,
      running: null // { term, startedAt, elapsed, reportId, failed }
    };
    this._alive = true;
  }
  componentDidMount() {
    publishSearch('Research');
    publishEvent('reset-search', {});
    this.ensurePolling();
  }
  componentWillUnmount() {
    this._alive = false;
    clearInterval(this._tick);
    clearInterval(this._poll);
    clearInterval(this._listPoll);
  }

  // Poll the list while any row is still running.
  ensurePolling() {
    const anyRunning = this.state.rows.some(r => !isDone(r) && !isFailed(r));
    if (anyRunning && !this._listPoll) this._listPoll = setInterval(this.refreshRows, 8000);
    if (!anyRunning && this._listPoll) {
      clearInterval(this._listPoll);
      this._listPoll = null;
    }
  }
  renderRunStrip() {
    const r = this.state.running;
    if (!r) return null;
    const stop = () => {
      clearInterval(this._tick);
      clearInterval(this._poll);
      this.setState({
        running: null
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "apr-strip"
    }, r.reportId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-dot ok"
    }), /*#__PURE__*/React.createElement("span", null, "The \"", r.term, "\" report is ready."), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.props.history.push(`/Research/Trends/Detail/${r.reportId}`)
    }, "Open it")) : r.failed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-dot bad"
    }), /*#__PURE__*/React.createElement("span", null, "The \"", r.term, "\" report did not finish. Try again with New trend report.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "apr-spinner"
    }), /*#__PURE__*/React.createElement("span", null, "Building \"", r.term, "\"\u2026 ", r.elapsed ? `${Math.floor(r.elapsed / 60)}:${String(r.elapsed % 60).padStart(2, "0")}` : ""), /*#__PURE__*/React.createElement("span", {
      className: "apr-muted"
    }, "takes 1 to 2 minutes")), /*#__PURE__*/React.createElement("a", {
      className: "apr-muted apr-dismiss",
      onClick: stop
    }, "Dismiss"));
  }
  renderModal() {
    if (!this.state.modal) return null;
    const {
      term,
      locationSel,
      windowSel,
      categoryCode,
      submitting
    } = this.state;
    const inp = {
      width: "100%",
      padding: "8px 10px",
      border: "1px solid var(--plk-border)",
      borderRadius: "6px",
      fontSize: "13px",
      background: "var(--plk-surface, #fff)"
    };
    const lbl = {
      display: "block",
      fontSize: "10.5px",
      textTransform: "uppercase",
      letterSpacing: ".06em",
      color: "var(--plk-text-dim)",
      fontWeight: 600,
      marginBottom: "3px"
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "mtf-overlay",
      onClick: () => !submitting && this.setState({
        modal: false
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "mtf-modal",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "mtf-head"
    }, /*#__PURE__*/React.createElement("h2", null, "New market trend report"), /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        modal: false
      }),
      className: "mtf-dim",
      style: {
        cursor: "pointer"
      }
    }, "\u2715")), /*#__PURE__*/React.createElement("div", {
      className: "mtf-body"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Term, product, or category"), /*#__PURE__*/React.createElement("input", {
      style: inp,
      autoFocus: true,
      value: term,
      placeholder: "e.g. eco-friendly packaging",
      onChange: e => this.setState({
        term: e.target.value
      }),
      onKeyDown: e => {
        if (e.key === "Enter") this.submit();
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "6px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "mtf-dim",
      style: {
        fontSize: "11px",
        marginRight: "4px"
      }
    }, "Try:"), TERM_CHIPS.map(c => /*#__PURE__*/React.createElement("button", {
      key: c,
      className: "mtf-chip",
      onClick: () => this.setState({
        term: c
      })
    }, c)))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "12px",
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Location"), /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: locationSel,
      onChange: e => this.setState({
        locationSel: e.target.value
      })
    }, /*#__PURE__*/React.createElement("option", null, "United States"), Object.values(US_STATES).map(n => /*#__PURE__*/React.createElement("option", {
      key: n
    }, n)))), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Time window"), /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: windowSel,
      onChange: e => this.setState({
        windowSel: e.target.value
      })
    }, WINDOWS.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      style: lbl
    }, "Category ", /*#__PURE__*/React.createElement("span", {
      style: {
        textTransform: "none",
        fontWeight: 400
      }
    }, "(optional: helps with terms that mean several things)")), /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: categoryCode,
      onChange: e => this.setState({
        categoryCode: Number(e.target.value)
      })
    }, CATEGORIES.map(([v, l]) => /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l))), /*#__PURE__*/React.createElement("div", {
      className: "mtf-dim",
      style: {
        fontSize: "11px",
        marginTop: "4px"
      }
    }, "Leave on Auto unless the term is ambiguous (\"java\", \"fall\")."))), /*#__PURE__*/React.createElement("div", {
      className: "mtf-foot"
    }, /*#__PURE__*/React.createElement("span", {
      className: "mtf-dim",
      style: {
        fontSize: "11px"
      }
    }, "Takes 1 to 2 minutes"), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto"
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        modal: false
      }),
      disabled: submitting
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: !term.trim() || submitting,
      onClick: this.submit
    }, submitting ? "Starting…" : "Run report"))));
  }
  render() {
    const {
      rows,
      pill,
      search
    } = this.state;
    // Parsing each run's data blob is the costly part; redo it only when the rows change.
    if (!this._enriched || this._enriched.rows !== rows) {
      this._enriched = {
        rows,
        out: rows.map(r => {
          const done = isDone(r);
          const dir = done ? trendDirection(weeklySeries(parseTrendData(r.data).gt)) : null;
          return {
            r,
            id: rowId(r),
            done,
            dir
          };
        })
      };
    }
    const enriched = this._enriched.out;
    const pills = [{
      k: "all",
      label: "All",
      count: enriched.length
    }];
    ["Rising", "Steady", "Cooling", "Falling"].forEach(w => {
      const n = enriched.filter(x => x.dir && x.dir.word === w).length;
      if (n && n < enriched.length) pills.push({
        k: w,
        label: w,
        count: n
      });
    });
    const q = search.trim().toLowerCase();
    const list = enriched.filter(x => pill === "all" || x.dir && x.dir.word === pill).filter(x => !q || `${x.r.term || ""} ${x.r.location || ""}`.toLowerCase().includes(q));
    const pctText = p => p == null ? "" : ` ${p > 0 ? "+" : ""}${p}%`;
    const tableRows = list.map(x => ({
      id: x.id,
      open: x.done ? () => this.props.history.push(`/Research/Trends/Detail/${x.id}`) : null,
      cells: [/*#__PURE__*/React.createElement("span", {
        className: "apr-name apr-cap"
      }, /*#__PURE__*/React.createElement("b", null, x.r.term)), x.r.location || "United States", periodText(x.r.fromDate, x.r.toDate), x.done ? x.dir ? /*#__PURE__*/React.createElement("span", null, x.dir.word, /*#__PURE__*/React.createElement("span", {
        className: x.dir.pct > 0 ? "apr-up" : x.dir.pct < 0 ? "apr-down" : "apr-muted"
      }, pctText(x.dir.pct))) : /*#__PURE__*/React.createElement("span", {
        className: "apr-muted"
      }, "Not enough data") : /*#__PURE__*/React.createElement(StatusChip, {
        row: x.r
      }), readableDate(x.r.createdDate)]
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view apr-root"
    }, /*#__PURE__*/React.createElement("header", {
      className: "apr-hdr"
    }, /*#__PURE__*/React.createElement("div", {
      className: "apr-hdr-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "apr-crumb"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Apps"
    }, "Apps"), " \xB7 Market Trends"), /*#__PURE__*/React.createElement("h1", null, "Market Trends"), /*#__PURE__*/React.createElement("span", {
      className: "apr-sub"
    }, "How much people search for a term over time, where it is heading and what to do about it")), /*#__PURE__*/React.createElement("div", {
      className: "apr-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: () => this.setState({
        modal: true
      })
    }, "New trend report"))), this.renderRunStrip(), this.renderModal(), /*#__PURE__*/React.createElement(AprListCard, {
      pills: pills,
      pill: pill,
      onPill: k => this.setState({
        pill: k
      }),
      search: search,
      onSearch: v => this.setState({
        search: v
      }),
      placeholder: "Search terms",
      head: [{
        label: "Term"
      }, {
        label: "Where"
      }, {
        label: "Period"
      }, {
        label: "Direction"
      }, {
        label: "Created"
      }],
      rows: tableRows,
      onDelete: this.onDelete,
      empty: rows.length ? "No reports match." : "No trend reports yet. Use New trend report to run your first one."
    }));
  }
}
export class MarketTrendsViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }

  // The endpoint returns every run; the list searches, filters and pages
  // on the client.
  async fetchData() {
    var Service = ServiceFactory.getType('/market-trends', 'research');
    var service = new Service();
    try {
      let data = await service.getAsync();
      this.data = Array.isArray(data) ? data : data && data.items || [];
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  MarketTrendsViewComponent
};